namespace Areas.Employee.Activity {
    "use strict";

    let startDate: string;
    let endDate: string;

    export function timeOffGridInitialized (e: any) {
        const form = $('#TimeOffFilterForm').dxForm('instance');
        const today = moment(Date.now());

        endDate = today.format("YYYY-MM-DD");
        startDate = today.add(-3650, 'day').format("YYYY-MM-DD");

        const data = {
            start: startDate,
            end: endDate 
        };

        form.option("formData", data);
    }

    export function timeOffFilterFormDataChanged(e: any) {
        if (Areas.isEmpty(e.value)) return;
        
        if (e.dataField == "start") {
            startDate = moment(e.value).format("YYYY-MM-DD");
        } else {
            endDate = moment(e.value).format("YYYY-MM-DD");
        }

        if (Areas.isNotEmpty(startDate) && Areas.isNotEmpty(endDate)) {
            Areas.refreshGrid("TimeOffGrid");
        }
    }

    export function getStartDate() {
        return startDate;
    }

    export function getEndDate() {
        return endDate;
    }

    export function appointmentRendered(e, f) {
        if (!e.appointmentData.employeeActivityId) {
            e.appointmentElement.addClass('dx-scheduler-red');
        }
    }
    
    export function ConvertToFMLA() {
        var dataGrid = $('#TimeOffGrid').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowKeys().join(',');
        var url = "/Employee/Activity/ConvertToFMLA/?ids=" + selectedRows;

        sendRequest(url, "", "POST", () => { $('#TimeOffGrid').dxDataGrid("instance").refresh(); });
    }

    export function newActivity(e) {
        e.data.employeeId = $('#ActivityGrid').dxDataGrid('instance').option('EmployeeId');
    }

    export function activityGridUpdated(e) {
        $('#ActivityScheduler').dxScheduler('instance').repaint();
    }

    export function showAddActivities() {
        const parameters = { employeeId: $('#ActivityGrid').dxDataGrid('instance').option('EmployeeId') };

        var addEmployeeActivityDialog = new Areas.Dialogs.EmployeeActivity.AddEmployeeActivityDialog(
            addEmployeeActivityDialogClosing, parameters);
    }

    function addEmployeeActivityDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        $('#ActivityGrid').dxDataGrid('instance').refresh();
        $('#ActivityScheduler').dxScheduler('instance').repaint();
   }
 
}